"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_context_1 = require("../_util/config-context");
/**
 * TabPanel 应该用在 Tabs 内部，如果单独使用，会直接渲染其 children
 */
exports.TabPanel = react_1.default.forwardRef(function TabPanel(_a, ref) {
    var children = _a.children, id = _a.id, forceRender = _a.forceRender, className = _a.className, _b = _a.style, style = _b === void 0 ? {} : _b, props = tslib_1.__rest(_a, ["children", "id", "forceRender", "className", "style"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-tabs__tabpanel", className), style: tslib_1.__assign(tslib_1.__assign({}, style), { flexShrink: 0 }) }, props), children));
});
exports.TabPanel.displayName = "TabPanel";
//# sourceMappingURL=TabPanel.js.map